import { FC } from 'react';
import styled, { css } from 'styled-components';
import { Box, Button, ButtonProps, ButtonSize, ButtonAppearance } from '@bechtel/gds';

export const ShiftLogStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  opacity: 0.5;
  pointer-events: none;
  overflow-y: auto;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radii[300]};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  @media only screen and (max-height: ${({ theme }) => theme.breakpoints.tablet}) and (min-width: ${({ theme }) =>
      theme.breakpoints.widescreen}) {
    max-height: 154px;
  }
`;

export const ShiftLogHeaderStyled = styled(Box).attrs({
  py: { sm: '400' },
  px: { sm: '500' },
  alignItems: { sm: 'center' },
})`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
`;

export const ShiftLogBodyStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  width: '100%';

  & > :not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  }
`;

export const ShiftLogItemStyled = styled(Box).attrs({
  py: { sm: '500' },
  pl: { sm: '600' },
  pr: { sm: '500' },
  alignItems: { sm: 'center' },
})`
  width: '100%';
`;

export const ShiftLogCommentStyled = styled(Box).attrs({ mr: { sm: '700' } })`
  position: relative;
`;

export const ShiftLogCommentCountStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  pt: { sm: '200' },
  px: { sm: '200' },
  pb: { sm: '100' },
})`
  position: absolute;
  border-radius: ${({ theme }) => theme.radii[900]};

  right: -10px;
  background-color: white;
`;

export const ShiftLogWeekStyled = styled(Box).attrs({ px: { sm: '200' }, flexShrink: { sm: 0 } })`
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
`;

export interface TabButtonProps extends ButtonProps {
  selected: boolean;
}

export const TabButtonStyled = styled(Button as FC<TabButtonProps>).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.LARGE,
})`
  border: none;
  border-radius: 0;
  position: relative;
  opacity: 0.5;
  &:focus {
    border-color: transparent;
    box-shadow: none;
  }
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.grey[1000]};
    font-size: ${theme.fontSizes['400']};
    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 5px;
      background-color: ${theme.colors.blue['700']};
      opacity: 0;
    }
  `};
  ${(props) =>
    props.selected &&
    css`
      color: ${props.theme.colors.blue[700]};
      font-weight: ${props.theme.fontWeights[600]};
      opacity: 1;
      &::after {
        opacity: 1;
      }
    `};
`;
